export const version = "wallet/5.0.4";
//# sourceMappingURL=_version.js.map